
const baseOss={
  dev: 'https://gdhy-oss.hebeigaoda.com',
  pro: 'https://gdhy-oss.hebeigaoda.com',
  uat:'https://gdhy-oss.hebeigaoda.com'
}
export default {
  COMPANYNAME:'高大永恒塑料制品有限公司',
  baseUrl: {
    dev: 'https://pps-api.hebeigaoda.com/',
    pro: 'https://pps-api.hebeigaoda.com/',
    uat:'https://pps-api.hebeigaoda.com/'
  },
  cloudUrl:{
    dev: 'https://yd.hebeigaoda.com/',
    pro: 'https://yd-admin.hebeigaoda.com/',
    uat:'https://yd.hebeigaoda.com/'
  },
  smartUrl:{
    dev: 'https://smart-api.hebeigaoda.com/',
    pro: 'https://smart-api.hebeigaoda.com/',
    uat:'https://smart-api.hebeigaoda.com/'
  },
  onlineOrderUrl:{
    dev: 'https://online-order-api.hebeigaoda.com/',
    pro: 'https://fch-api.hebeigaoda.com/',
    uat:'https://online-order-api.hebeigaoda.com/'
  },
  oss:{
    dev: 'https://gdhy-oss.hebeigaoda.com/',
    pro: 'https://gdhy-oss.hebeigaoda.com/',
    uat:'https://gdhy-oss.hebeigaoda.com/'
  },
  mapKey: {
    // 高德地图 JS API Key，dev 与 uat 共用
    dev: "27838bdf711b144912c554745e3a577f",
    pro: "27838bdf711b144912c554745e3a577f",
    uat: "27838bdf711b144912c554745e3a577f",
  },
    mapSecretKey: {
    //地图密钥（代理服务器域名)  dev，uat共用
    dev: "https://gps-jscode.hebeigaoda.com/_AMapService",
    pro: "https://gps-jscode.hebeigaoda.com/_AMapService",
    uat: "https://gps-jscode.hebeigaoda.com/_AMapService",
  },
}
